
import { Popover} from '@mui/material';
import { useEffect, useState } from 'react';
import { StatusEnum } from '../../common/IExportNotificationMsg';
import { useProgressContext } from '../../contexts/progress-context/ProgressContext';
import { useNotificationMessages } from '../../queries/notification-messages/UseNotificationMessagess';
import { useQueryNotifications } from '../../queries/UseQueryNotifications';
import NotificationButton from './NotificationButton';
import UserMessageList from './UserMessageList';
import {isMobile, isTablet} from 'react-device-detect';
import { useUserContext } from '../../contexts/user-context/UserContext';

export default function UserMessages() {

    const isPhone = isMobile && !isTablet;
    const [anchorEl, setAnchorEl] = useState<HTMLButtonElement>();
    const [progressState] = useProgressContext();

    const [userState] = useUserContext();

    const {data: messages,
        refetch
    } = useQueryNotifications(useNotificationMessages)({
        groupID: userState.startGroupID as number,
        enabled: (userState.startGroupID ?? 0) > 0
    });

    const open = Boolean(anchorEl);
    const id = open ? 'user-messsages-popover' : undefined;

    const onButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {

        setAnchorEl(event.currentTarget);
    };

    const onClose = () => {
        setAnchorEl(undefined);
    };


    useEffect(() => {
        const progress = progressState.items.find(o => o.notificationMsg?.status === StatusEnum.Completed);
        if (progress) {
            //console.log(`app header progress comleted: ${progress?.title}`)
            refetch();
        }
    }, [
        progressState.items,
        refetch
    ]);

    return (
        <>
            <NotificationButton count={messages?.length ?? 0} onClick={onButtonClick} />

            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={onClose}
                anchorOrigin={{
                    vertical: isPhone ? 'top' : 'bottom',
                    horizontal: 'right',
                }}>
                <UserMessageList onClose={onClose} />
            </Popover>
        </>
    );
}



